import { reactive, toRefs, set, nextTick } from 'vue'
import { Message } from 'view-design'
import { modifyBudgetNew, modifyBidNew, modifyRoiRatio, batchBudgetModify } from '@/api/convert.model'
import { getThirdAdIdByplanIds, modifyRoi } from '@/api/ptom.data.model'
import { isArray } from '@/common/js/utils'
import { clone } from '@/common/js/just'
import { MessageBox } from 'element-ui'
import { gotoAuthorize, getAuthInfo } from '@/common/js/gdtAuthUtil.js'

export function useCellEdit(props, emit, selectList) {
  const state = reactive({
    budgetModifyModal: false,
    budgetModifyResultsModal: false,
    batchModifyRows: [],
    batchModifyResultList: [],
    batchModifyModalTitle: ''
  })

  const showAdBudgetActionComponent = (row) => {
    if (row.touTiaoUba) return false
    if (row.mediaId === 45) return false
    if (!row.allowOperation) return false
    return true
  }

  const closeManualPopover = () => {
    props.data.forEach((item) => {
      set(item, 'showBudgetEditPopover', false)
      set(item, 'showAdBudgetEditPopover', false)
    })
  }

  const showProjectBatchBudgetModal = () => {
    if (!selectList.value?.length) return Message.info('请选择至少一个计划！')
    state.budgetModifyModal = true
    state.batchModifyModalTitle = '批量修改项目/组预算'
    state.batchModifyRows = clone(selectList.value).map((s) => ({
      ...s,
      budgetRadio: s.bookProjectBudget > 0 ? 1 : 0,
      modifiedBudgetValue: null
    }))
  }

  const showPlanBatchBudgetModal = () => {
    if (!selectList.value?.length) return Message.info('请选择至少一个计划！')
    state.budgetModifyModal = true
    state.batchModifyModalTitle = '批量修改计划预算'
    state.batchModifyRows = clone(selectList.value).map((s) => ({
      ...s,
      budgetRadio: s.bookAdBudget > 0 ? 1 : 0,
      modifiedBudgetValue: null
    }))
  }

  const onReserveBudgetModify = (row, key) => {
    if (key === 'projectDayBudget') {
      set(row, 'showBudgetActionPopover', false)
      nextTick(() => {
        set(row, 'showBudgetEditPopover', true)
      })
    }
    if (key === 'budget') {
      set(row, 'showAdBudgetActionPopover', false)
      nextTick(() => {
        set(row, 'showAdBudgetEditPopover', true)
      })
    }
  }

  const buildEditReserveBudgetSubmitParams = (row, key) => {
    const task = {
      media_id: row.mediaId,
      biz_name: row.planName,
      enable_book: 1,
      plan_id: row.planId
    }

    if (key === 'projectDayBudget') {
      task.biz_type = 2
      task.biz_id = row.projectIdForBudget
      if (row.reserveBudgetRadio === 1) {
        if (Math.abs(row.projectDayBudget - row.bookProjectBudgetDup) < 100) {
          throw new Error('预约预算增减幅度不能小于100')
        }
        if (row.bookProjectBudgetDup < 300) {
          throw new Error('预约预算不能小于300')
        }
        task.target_budget = row.bookProjectBudgetDup
      } else {
        if (row.touTiaoUba) {
          throw new Error('当前计划不能设置为不限预算，请设置具体预算值')
        }
        task.target_budget = 0
      }
    }

    if (key === 'budget') {
      task.biz_type = 3
      task.biz_id = row.adIdForBudget
      if (row.reserveAdBudgetRadio === 1) {
        if (Math.abs(row.bookAdBudget - row.bookAdBudgetDup) < 100) {
          throw new Error('预约预算增减幅度不能小于100')
        }
        if (row.bookAdBudgetDup < 300) {
          throw new Error('预约预算不能小于300')
        }
        task.target_budget = row.bookAdBudgetDup
      } else {
        if (row.mediaId === 10) {
          throw new Error('当前计划不能设置为不限预算，请设置具体预算值')
        }
        task.target_budget = 0
      }
    }

    return {
      batch_task_type: 2,
      task_list: [task]
    }
  }

  const onReserveBudgetSave = (row, key) => {
    try {
      const params = buildEditReserveBudgetSubmitParams(row, key)
      batchBudgetModify(params).then((data) => {
        if (data) {
          Message.success('修改预约预算成功')
          emit('on-refresh')
        }
      })
    } catch (e) {
      Message.error(e.message)
    }
  }

  const onReserveBudgetRemove = (row, key) => {
    let biz_id = ''
    let biz_type = 2

    if (key === 'projectDayBudget') {
      biz_id = row.projectIdForBudget
      biz_type = 2
    }
    if (key === 'budget') {
      biz_id = row.adIdForBudget
      biz_type = 3
    }
    const params = {
      batch_task_type: 2,
      task_list: [{ biz_type, biz_id, media_id: row.mediaId, enable_book: 0 }]
    }
    batchBudgetModify(params).then((data) => {
      if (data) {
        Message.success('取消预约成功')
        set(row, 'showBudgetActionPopover', false)
        set(row, 'showAdBudgetActionPopover', false)
        emit('on-refresh')
      }
    })
  }

  const modifyRowBidValue = (params, row) => {
    set(row, 'optLoading', true)
    modifyBidNew(params)
      .then((data) => {
        if (data) {
          Message.success('修改成功')
          emit('on-refresh')
        }
      })
      .finally(() => {
        set(row, 'optLoading', false)
      })
  }

  const onCellEdit = async (row, column, e) => {
    const newVal = e[0]
    set(row, 'optLoading', true)
    const mediaId = row.mediaId

    if (mediaId === 16) {
      const dateText = await getAuthInfo()
      if (!dateText) {
        MessageBox.alert('腾讯投放计划需要扫码认证，你的投放认证已经失效或者未认证。', '提示', {
          confirmButtonText: '去认证',
          callback: (action) => {
            if (action === 'confirm') {
              gotoAuthorize(window.location.href)
            }
          }
        })
        return
      }
    }

    if (column === 'bid') {
      modifyRowBidValue({ planId: row.planId, type: 2, value: newVal, deepType: 1 }, row)
    } else if (column === 'deepCpabid') {
      modifyRowBidValue({ planId: row.planId, type: 2, value: newVal, deepType: 2 }, row)
    } else if (column === 'projectTargetBid') {
      modifyRowBidValue({ planId: row.planId, type: 1, value: newVal, deepType: 1 }, row)
    } else if (column === 'projectDeepBid') {
      modifyRowBidValue({ planId: row.planId, type: 1, value: newVal, deepType: 2 }, row)
    } else if (['roiRatio', 'projectRoi'].includes(column) && [10, 16].includes(mediaId)) {
      const params = { planId: row.planId, value: newVal, type: column === 'roiRatio' ? 2 : 1 }
      modifyRoi(params).then((data) => {
        set(row, 'optLoading', false)
        if (data) {
          Message.success('修改成功')
          emit('on-refresh')
        }
      })
    } else if (column === 'roiRatio') {
      getThirdAdIdByplanIds([row.planId]).then((data) => {
        if (isArray(data) && data.length) {
          const { adId } = data.pop()
          const params = { adAccountId: row.adAccountId, adId, roiRatio: newVal }
          modifyRoiRatio(params).then((res) => {
            set(row, 'optLoading', false)
            if (res) {
              Message.success('修改成功')
              set(row, 'editRoiRatio', false)
              emit('on-refresh')
            }
          })
        } else {
          Message.error('获取第三方媒体计划ID失败，Code: 20005')
        }
      })
    }
  }

  const modifyRowBudgetValue = (params, row) => {
    set(row, 'optLoading', true)
    modifyBudgetNew(params)
      .then((data) => {
        if (data) {
          Message.success('修改成功')
          emit('on-refresh')
        }
      })
      .finally(() => {
        set(row, 'optLoading', false)
      })
  }

  const saveBudget = (row, field) => {
    const { newValue, radioState } = row

    if (radioState && !newValue) {
      Message.error('预算不能为空，如设置为‘0’请选择不限！')
      return
    }

    if (radioState === 1 && newValue < 300) {
      return Message.error('预算不能小于300')
    }

    if (radioState === 1 && Math.abs(newValue - row[field]) < 100) {
      return Message.error('预算增减幅度不能小于100')
    }

    if (row.mediaId === 10) {
      if (field === 'budget') {
        if (row.touTiaoUba) return Message.error('当前计划不能修改预算')
        else if (radioState === 0) return Message.error('当前计划不能设置为不限预算')
      }
      if (field === 'projectDayBudget') {
        if (row.touTiaoUba && radioState === 0) {
          return Message.error('当前计划不能设置为不限预算')
        }
      }
    }
    const value = radioState === 1 ? newValue : 0
    const params = { planId: row.planId, value }

    switch (field) {
      case 'budget':
        params.type = 2
        modifyRowBudgetValue(params, row)
        break
      case 'projectDayBudget':
        params.type = 1
        modifyRowBudgetValue(params, row)
        break
    }
  }

  const onShowBatchModifyResults = (resultRows) => {
    state.budgetModifyResultsModal = true
    state.batchModifyResultList = resultRows
  }

  const editBudget = async (row, key) => {
    const nolimit = row[key] === 0
    set(row, 'radioState', nolimit ? 0 : 1)
    set(row, 'newValue', row[key] || 0)
  }

  return {
    ...toRefs(state),
    showAdBudgetActionComponent,
    closeManualPopover,
    showProjectBatchBudgetModal,
    showPlanBatchBudgetModal,
    onReserveBudgetModify,
    onReserveBudgetSave,
    onReserveBudgetRemove,
    onCellEdit,
    saveBudget,
    onShowBatchModifyResults,
    editBudget
  }
}
